<template>
  <IdentityContext>
    <v-row>
      <v-col cols="12" lg="8">
        <IdentityStatus />
      </v-col>
    </v-row>
  </IdentityContext>
</template>

<script lang="ts" setup>
import IdentityContext from '@/components/deepadmin/identity/IdentityContext.vue'
import IdentityStatus from '@/components/deepadmin/identity/IdentityStatus.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.personal.my_identity',
  },
})
</script>
